// apps/vendor/src/pages/settings/SecurityCenterPage.tsx
//
// Phase 1 Wave 12 Task 104 — Vendor Security Center thin wrapper.

import {
  SecurityCenterPage as SharedSecurityCenter,
  SettingsLayout,
} from '@printway/ui';

export function SecurityCenterPage(): JSX.Element {
  return (
    <SettingsLayout portal="vendor" activeTab="security">
      <SharedSecurityCenter />
    </SettingsLayout>
  );
}

export default SecurityCenterPage;
